export const SEARCH_FILTERS = [
  {
    id: "visit" as const,
    options: [
      { value: "all", label: "All types" },
      { value: "1", label: "In-person only" },
      { value: "2", label: "Telehealth only" },
    ],
    placeholder: "Consultation type",
  },
  {
    id: "price" as const,
    options: [
      { value: "all", label: "All prices" },
      { value: "300", label: "Under $300" },
      { value: "400", label: "Under $400" },
    ],
    placeholder: "Price range",
  },
] as const;

export const INITIAL_SEARCH_FILTERS = { visit: "all", price: "all" } as const;

export const TELEHEALTH_BADGE = {
  label: "Telehealth",
  className: "bg-sky-100 text-sky-700",
};

export const IN_PERSON_BADGE = {
  label: "In-Person",
  className: "bg-indigo-100 text-indigo-700",
};

export const PREFERRED_BADGE = {
  label: "Preferred",
  className:
    "bg-gradient-to-r from-amber-100 to-amber-50 text-amber-800 ring-1 ring-inset ring-amber-300/70",
};

export const CARD_STYLE =
  "w-full border border-border bg-card shadow-[0_4px_14px_0_rgba(46,101,255,0.2)]";

export const SLOT_BTN_BASE =
  "border rounded-md px-3 py-2 text-sm sm:text-base transition-all duration-200";

export const SLOT_BTN_TELEHEALTH =
  `${SLOT_BTN_BASE} border-sky-400 text-sky-700 hover:bg-sky-100 hover:text-sky-800`;

export const SLOT_BTN_IN_PERSON =
  `${SLOT_BTN_BASE} border-indigo-400 text-indigo-700 hover:bg-indigo-100 hover:text-indigo-800`;

export const INPUT_WHITE =
  "[&_input]:bg-white/90 [&_input]:border-white/20 [&_input]:text-foreground";
